import * as _ from 'lodash';
import { I18nPluralPipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { of, Subject, timer } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { selectOrgUser, userRecentDonation } from '../../features/dashboard.selectors';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-donor-table',
  templateUrl: './dashboard-donor-table.component.html',
  styleUrls: ['./dashboard-donor-table.component.scss'],
  providers: [I18nPluralPipe]
})
export class DashboardDonorTableComponent implements OnInit, OnDestroy {

  public orgUser = null;
  public orgUser$ = this.store.pipe(
    select(selectOrgUser),
    filter(user => !_.isNull(user)),
    filter((user: any) => {
      const { orgUser } = this;
      if(orgUser === null) {
        return true;
      }
      const { id: previousUserId, orgId: previousOrgId } = orgUser.loggedInUser || orgUser;
      const { id: currentUserId, orgId: currentOrgId } = user.loggedInUser || user;
      return previousUserId === currentUserId && previousOrgId === currentOrgId ? false: true;
    })
  );

  public showSeeAll$ = this.orgUser$.pipe(
    map((user) => {
      this.orgUser = user;
      const { access } = user.loggedInUser || {
        access: [1]
      };
      const { length } = _.intersection([1,2,4], access);
      return length > 0;
    })
  );
  
  public takeUntilSubject: Subject<any> = new Subject();
  public showRecentDonation = false
  public recentDonation$ = this.store.pipe(
    select(userRecentDonation),
    filter(list=>!_.isNull(list)),
    map((list: any[]) => {
        if(list.length !=0){
          this.showRecentDonation = true
        }
      return list.slice(0,10).map(item=> {
        const newItem = { ...item, date: timer(1000, 5000).pipe(
          mergeMap(() => {
            let result = Math.round(new Date().getTime()/1000) - item.date;
            return of(result);
          })
        ) }
        return newItem;
      })
    }),
  )

  constructor(
    private store: Store,
    private router: Router) { } 

  ngOnInit(): void {
  }

  getStringDate(timestamp){
     return (moment(new Date(timestamp*1000))).format("YYYY/MM/DD h:mm a")
  }
  
  onAllDonationsClick(){
    this.router.navigateByUrl('/reportAll');

  }
  getAmount(anount){
    let newAmount = Math.round(anount)
    return window['utils'].getAmountDisplay(newAmount);
  }

  ngOnDestroy() {
  }
}
